import { type TaskData, type TaskManagementInput, type TaskManagementSuccess } from '@terros/common'
import { type GetHookResponse } from '../hooks'
import { useTantalimQuery } from '../query'
import { useTaskCache } from './cache'
import { taskManagementKey } from './keys'

export function useTaskManagement(input: TaskManagementInput, enabled = true): GetHookResponse<TaskData[]> {
  const cache = useTaskCache()
  return useTantalimQuery<TaskManagementInput, TaskManagementSuccess, TaskData[]>({
    url: '/task/management',
    queryKey: taskManagementKey(input),
    input: input,
    convertResponse: (data) => {
      const { tasks } = data
      tasks.forEach((t) => cache.setItem(t))
      return tasks
    },
    options: {
      enabled,
    },
  })
}
